<template>
    <div class="container min-vh-100 d-flex align-items-center justify-content-center">
    <div class="card shadow-sm w-100" style="max-width: 400px; border-radius: 18px;">
      <div class="card-body d-flex flex-column align-items-center p-4">
        <img alt="logo" class="mb-3 rounded logo" src="@/assets/image.png" />
        <h2 class="h5 fw-bold text-center mb-3">Dapatkan Aplikasi "Hai Parahita"</h2>
        <div class="middle-card border w-100 mb-3 py-3 px-2 d-flex flex-column align-items-center">
          <p class="mb-0 text-center fw-400 color-neutral-600">Klik tombol di bawah untuk melanjutkan. <br> Anda akan diarahkan ke halaman ini di aplikasi</p>
        </div>
        <div class="fw-400 fs-12 color-neutral-600 mb-2 text-center">Powered by Parahita</div>
        <a
          :href="appLink"
          class="btn btn-primary w-100 mb-2 rounded-pill fw-semibold"
        >Lanjutkan</a>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  setup () {
    const baseLink = 'https://play.google.com/store/apps/details?id=com.parahita.android&referrer='

    const appLink = computed(() => {
      const route = useRoute()
      const id = route.params.id
      const encodedId = encodeURIComponent('id=' + id)
      return `${baseLink}${encodedId}`
    })

    return {
      appLink
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
    width: 200px;
    object-fit: contain;
}
.middle-card {
    border-radius: 12px;
}
.icon-row .icon {
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
}
.icon-row .icon-svg {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
